// Restored from the owner’s public WordPress site, 3 November 2026.
// Original dates and review wording preserved. No ratings or current-client claims inferred.
export const newsArticles = [
  {
    slug: "how-to-design-a-website-that-converts-insider-secrets-you-cant-afford-to-miss",
    title:
      "How to Design a Website That Converts: Insider Secrets You Can’t Afford to Miss",
    date: "2024-09-21",
    originalPath:
      "/2024/09/21/how-to-design-a-website-that-converts-insider-secrets-you-cant-afford-to-miss",
    image: "/images/news/website-conversions.jpg",
    excerpt:
      "A beautiful website is only the beginning. The true test of any site lies in its ability to convert visitors into paying customers. Here are some insider secrets…",
    blocks: [
      {
        type: "paragraph",
        text: "A beautiful website is only the beginning. The true test of any site lies in its ability to convert visitors into paying customers. Here are some insider secrets on web design that are proven to drive conversions.",
      },
      {
        type: "paragraph",
        text: "1. Simplify Navigation A well-structured, intuitive navigation system is the backbone of a successful website. When visitors can easily find what they’re looking for, they are more likely to stay, explore, and take action.",
      },
      {
        type: "paragraph",
        text: "2. Utilize White Space White space isn’t wasted space—it’s breathing room. A clean design that strategically uses white space will direct attention to important elements and improve overall readability.",
      },
      {
        type: "paragraph",
        text: "3. Prioritize Mobile Responsiveness With the majority of users now browsing on mobile devices, your website must offer a seamless experience across all platforms. Mobile-first design ensures that your site looks and functions perfectly on any device.",
      },
      {
        type: "paragraph",
        text: "4. Clear, Actionable CTAs Your call-to-action (CTA) buttons should stand out visually and offer clear instructions. Whether it’s “Get Started Today” or “Contact Us for a Free Consultation,” your CTAs should guide visitors toward conversion.",
      },
      {
        type: "paragraph",
        text: "5. Build Trust with Testimonials and Case Studies Including testimonials and case studies builds credibility and reassures potential customers that you can deliver on your promises. Display these prominently on your homepage or product pages for maximum effect.",
      },
      {
        type: "paragraph",
        text: "Designing a website that converts takes expertise and an understanding of your audience. We’ve helped countless businesses refine their web design for optimal results. If you’re ready to turn your website into a powerful conversion tool, reach out to Karalewich Consulting for a free consultation. Let us show you what’s possible.",
      },
    ],
    links: [],
  },
  {
    slug: "the-power-of-content-management-systems-why-wordpress-is-a-good-choice-for-your-website",
    title:
      "The Power of Content Management Systems: Why WordPress is a Good Choice for Your Website",
    date: "2024-09-04",
    originalPath:
      "/2024/09/04/the-power-of-content-management-systems-why-wordpress-is-a-good-choice-for-your-website",
    image: "/images/news/wordpress.jpg",
    excerpt:
      "With countless content management systems (CMS) available today, choosing the right one for your website is critical. Here’s why WordPress remains the industry…",
    blocks: [
      {
        type: "paragraph",
        text: "With countless content management systems (CMS) available today, choosing the right one for your website is critical. Here’s why WordPress remains the industry leader and why it might be the perfect solution for your business.",
      },
      {
        type: "paragraph",
        text: "1. User-Friendly Interface WordPress is incredibly user-friendly, even for those with little to no technical experience. Its intuitive dashboard allows you to update content, add pages, and manage media with ease.",
      },
      {
        type: "paragraph",
        text: "2. Endless Customization Options With thousands of themes and plugins available, WordPress offers endless customization options. You can tailor your website’s functionality to your exact needs without sacrificing design.",
      },
      {
        type: "paragraph",
        text: "3. SEO-Friendly WordPress is built with SEO in mind. From customizable permalinks to built-in optimization tools, WordPress makes it easier to optimize your website for search engines and boost your rankings.",
      },
      {
        type: "paragraph",
        text: "4. Security Features Security is a top priority, and WordPress offers numerous plugins and regular updates to keep your site safe from threats. With proper setup and maintenance, WordPress can provide a highly secure environment for your website.",
      },
      {
        type: "paragraph",
        text: "5. Scalable and Cost-Effective Whether you’re a small business just starting out or a larger company looking to scale, WordPress can grow with you. It offers the flexibility to expand your site’s features as your business evolves without needing a complete redesign.",
      },
      {
        type: "paragraph",
        text: "Choosing the right CMS can be daunting, but WordPress offers everything you need to build a professional, scalable website that delivers results. Want to take your WordPress website to the next level? Let Karalewich Consulting help you optimize and customize your site for success. Contact us today for expert guidance and support.",
      },
    ],
    links: [],
  },
  {
    slug: "why-seo-is-the-lifeline-of-your-website-expert-tactics-for-success",
    title:
      "Why SEO is the Lifeline of Your Website: Expert Tactics for Success",
    date: "2024-08-23",
    originalPath:
      "/2024/08/23/why-seo-is-the-lifeline-of-your-website-expert-tactics-for-success",
    image: "/images/news/seo.jpg",
    excerpt:
      "SEO (Search Engine Optimization) isn’t just a buzzword—it’s the key to driving organic traffic and keeping your website visible in an increasingly competitive…",
    blocks: [
      {
        type: "paragraph",
        text: "SEO (Search Engine Optimization) isn’t just a buzzword—it’s the key to driving organic traffic and keeping your website visible in an increasingly competitive landscape. Here’s why SEO is crucial and the expert tactics you should be implementing today.",
      },
      {
        type: "paragraph",
        text: "1. Keyword Optimization Research and strategically place high-value keywords throughout your website. Focus on long-tail keywords that are more specific to your services, which can lead to higher conversion rates from organic searches.",
      },
      {
        type: "paragraph",
        text: "2. High-Quality Content Content is king, and your website should offer valuable, relevant information to your audience. Regularly update your blog or resources page with informative articles that incorporate your targeted keywords naturally.",
      },
      {
        type: "paragraph",
        text: "3. On-Page SEO Elements Title tags, meta descriptions, header tags, and alt text for images are crucial elements that contribute to your overall SEO score. Each page should be optimized for both search engines and user experience.",
      },
      {
        type: "paragraph",
        text: "4. Build Backlinks Backlinks from authoritative sites signal to search engines that your content is valuable. Focus on creating shareable content and building relationships with other reputable websites in your industry to improve your SEO ranking.",
      },
      {
        type: "paragraph",
        text: "5. Website Speed and Mobile Optimization A fast, mobile-responsive website is a critical factor in SEO rankings. Search engines prioritize user experience, so ensure your site loads quickly and works flawlessly across all devices.",
      },
      {
        type: "paragraph",
        text: "SEO is an ongoing effort that requires in-depth knowledge and consistent work. At Karalewich Consulting, we stay ahead of the latest SEO trends and algorithms to ensure our clients’ websites rank high and stay competitive. Contact us to learn how we can help boost your website’s visibility and drive more organic traffic.",
      },
    ],
    links: [],
  },
  {
    slug: "5-essential-tips-to-supercharge-your-websites-performance",
    title: "5 Essential Tips to Supercharge Your Website’s Performance",
    date: "2024-06-08",
    originalPath:
      "/2024/06/08/5-essential-tips-to-supercharge-your-websites-performance",
    image: "/images/news/performance.jpg",
    excerpt:
      "In the fast-paced digital world, your website’s performance is directly tied to your success. A slow or poorly optimized website can drive potential customers…",
    blocks: [
      {
        type: "paragraph",
        text: "In the fast-paced digital world, your website’s performance is directly tied to your success. A slow or poorly optimized website can drive potential customers away before you even get a chance to engage them. Here are five expert-level tips that will instantly improve your website’s performance and keep visitors engaged.",
      },
      {
        type: "paragraph",
        text: "1. Optimize Your Images High-resolution images can slow down your website significantly. Use compressed images without sacrificing quality. Tools like TinyPNG or ImageOptim will reduce file sizes, making your site faster and more efficient.",
      },
      {
        type: "paragraph",
        text: "2. Leverage Browser Caching By enabling browser caching, you allow your website to store certain elements on a visitor’s browser so that when they return, your site loads much faster. This is a backend process, but it can drastically improve loading times.",
      },
      {
        type: "paragraph",
        text: "3. Minimize HTTP Requests Each element on your webpage, from scripts to stylesheets, makes an HTTP request. The more requests, the slower the page. Combine CSS files and reduce the number of plugins to streamline your website’s loading speed.",
      },
      {
        type: "paragraph",
        text: "4. Enable Gzip Compression Gzip compression significantly reduces the size of your CSS, HTML, and JavaScript files. Most modern web browsers support this feature, and enabling it on your server can reduce bandwidth usage and improve page speed.",
      },
      {
        type: "paragraph",
        text: "5. Invest in a Quality Hosting Provider Your hosting provider plays a crucial role in your website’s performance. While shared hosting might be cheaper, it often leads to slow load times. For businesses serious about their digital presence, a dedicated or cloud-based hosting solution is a must.",
      },
      {
        type: "paragraph",
        text: "Implementing these tips will set you ahead of your competition. But if you’re looking for tailored solutions that go beyond the basics, we’re here to help. At Karalewich Consulting, we specialize in optimizing websites to deliver both speed and superior user experience. Contact us today to learn how we can elevate your website’s performance to the next level.",
      },
    ],
    links: [],
  },
  {
    slug: "mini-hockey-scoreboard-update-submitted-to-apple",
    title: "Mini Hockey Scoreboard update submitted to Apple",
    date: "2022-11-27",
    originalPath:
      "/2022/11/27/mini-hockey-scoreboard-update-submitted-to-apple",
    image: "/images/news/hockey.jpg",
    excerpt:
      "Mini Hockey Scoreboard, with over 250 downloads in the United States, Canada, and Czech Republic, has been updated to include a new welcome screen and goal…",
    blocks: [
      {
        type: "paragraph",
        text: "Mini Hockey Scoreboard, with over 250 downloads in the United States, Canada, and Czech Republic, has been updated to include a new welcome screen and goal horns. Goal horns were generously provided by the YouTube Channel Famous Goal Horns . Additionally, feedback from players saw that the hundredths place on the seconds countdown (with under a minute left) was removed, and that the ability to rename teams was added. Next steps for the app include letting players select multiple scoreboard designs, adding shootout functionality, and the option to add arena noise (1 minute countdown, fans, and an end of period buzzer). We hope to continue to add features that are not available on other platforms, and we are working on technology that allows you to sink multiple different phones for the same game.",
      },
    ],
    links: [
      {
        url: "https://www.youtube.com/@FamousGoalHorns",
        label: "YouTube Channel Famous Goal Horns",
      },
    ],
  },
  {
    slug: "drebe-rebranded-to-fitcheck-new-update-coming-soon",
    title: "DreBe rebranded to FitCheck, new update coming soon",
    date: "2022-10-09",
    originalPath:
      "/2022/10/09/drebe-rebranded-to-fitcheck-new-update-coming-soon",
    image: "/images/news/fitcheck.png",
    excerpt:
      "DreBe has been renamed to FitCheck, and has been updated across the Apple App Store to reflect this change. The new name does a much better job of explaining the…",
    blocks: [
      {
        type: "paragraph",
        text: "DreBe has been renamed to FitCheck, and has been updated across the Apple App Store to reflect this change. The new name does a much better job of explaining the functionality of the app, and it appeals much more to our target audience. The default theme of the app has also been changed to light as well, for the same reason.",
      },
    ],
    links: [],
  },
  {
    slug: "drebe-will-be-entering-beta-testing-in-the-coming-days",
    title: "DreBe will be entering Beta testing in the coming days",
    date: "2022-04-03",
    originalPath:
      "/2022/04/03/drebe-will-be-entering-beta-testing-in-the-coming-days",
    image: "/images/news/fitcheck.png",
    excerpt:
      "DreBe has announced that it will be testing its app over the coming weeks. Groups of college students will download the app on their phone and provide feedback…",
    blocks: [
      {
        type: "paragraph",
        text: "DreBe has announced that it will be testing its app over the coming weeks. Groups of college students will download the app on their phone and provide feedback to developers. After this initial stage of testing, the app will be submitted for review on the Apple App Store. Stay tuned, we are very close to a release!",
      },
    ],
    links: [],
  },
];
export const testimonials = [
  {
    name: "Chris Keosayian",
    image: "/images/testimonials/chris-keosayian.jpeg",
    quote:
      "Very happy with the work Karalewich provided on our recent project. Delivered on time and exceeded our expectations. Look forward to working with the team again soon.",
  },
  {
    name: "Matt Rennie",
    image: "/images/testimonials/matt-rennie.webp",
    quote:
      "Vasili is an excellent website manager/developer who is always available for consultation. He is easy to communicate with and provides stellar work and advice. Highly recommend!",
  },
  {
    name: "Eric Bicknese",
    image: "/images/testimonials/eric-bicknese.jpg",
    quote:
      "He knows what he is doing when it comes to the websites and marketing, and is a great resource to have for any business owner",
  },
  {
    name: "Artie Carril",
    image: "/images/testimonials/artie-carril.png",
    quote:
      "Extremely professional and easy to work with. Saw their ad on a billboard and I’m so thankful that I did. Extremely good at communicating, and working towards exactly what I was looking for. Great job through the development of their websites and apps. look forward to working on more projects in the future with the help of Karalewich.",
  },
  {
    name: "Michael Grassi",
    image: "/images/testimonials/michael-grassi.webp",
    quote:
      "Great company for websites, graphic design, social media marketing and more. Our website and online store was put up and running within days of providing all of our information and the price was extremely reasonable, especially for our startup.",
  },
  {
    name: "Arnold Pollikoff",
    image: null,
    quote:
      "Vasili is such a welcome addition to our company. He and his company are the most caring and conscientious of all the web people that we have employed in the past. He understands the importance of our needs. He is foresightful, always trying to help and improve our site, as well as offering his assistance even when not part of our contracted needs. He has a ‘brain’, and that is refreshing. I highly recommend him. oh, one last note: there are no language barriers.",
  },
];
export const organizations = [
  {
    name: "Eric Bicknese",
    image: "/images/organizations/eric-bicknese.png",
  },
  {
    name: "TIAA",
    image: "/images/clients/tiaa.svg",
  },
  {
    name: "CarePoint Health",
    image: "/images/organizations/carepoint-health.png",
  },
  {
    name: "Asset Preservation",
    image: "/images/organizations/asset-preservation.png",
  },
  {
    name: "Ice House",
    image: "/images/organizations/ice-house.png",
  },
  {
    name: "Shipyard Marina",
    image: "/images/organizations/shipyard-marina.png",
  },
];
export const portfolioApps = [
  {
    name: "Consulting with TIAA",
    id: "tiaa",
    headline: "Exploring AI in retirement engagement.",
    description:
      "Karalewich presented to TIAA on how artificial intelligence and web technology could support retirement advising and engagement. The published product concept explores an AI-assisted experience.",
    image: "/images/tiaa-app.png",
    alt: "Retirement-engagement application concept from the published TIAA consulting project",
    category: "AI CONSULTING · PRODUCT CONCEPT",
    logo: "/images/clients/tiaa.svg",
  },
  {
    name: "StoveWatch",
    id: "stovewatch",
    headline: "Several dishes. One place to follow the cooking.",
    description:
      "Plan dishes, follow cooking steps, and run multiple timers together. A cooking application designed around the practical details of preparing a meal.",
    image: "/images/portfolio/stovewatch.png",
    alt: "Original StoveWatch phone and tablet screenshots",
    category: "PLANNING & TIMERS",
  },
  {
    name: "FitCheck",
    id: "fitcheck",
    headline: "A digital closet, built for everyday use.",
    description:
      "Photograph outfits, organize a personal closet, and browse a calendar of what was worn. A social application with a visual, mobile-first experience.",
    image: "/images/portfolio/fitcheck.png",
    alt: "Original FitCheck app preview from the Karalewich portfolio",
    category: "SOCIAL & LIFESTYLE",
  },
  {
    name: "Mini Hockey Scoreboard",
    id: "hockey",
    headline: "A scoreboard made for the game.",
    description:
      "A compact scoreboard with an adjustable game clock and penalty tracking. The original product preview shows the application in use.",
    image: "/images/portfolio/hockey-scoreboard.gif",
    still: "/images/news/hockey.jpg",
    alt: "Original animated Mini Hockey Scoreboard application preview",
    category: "LIVE GAME CONTROLS",
  },
  {
    name: "VEL",
    id: "vel",
    headline: "Power consumption, made visible.",
    description:
      "An application interface for a home electricity-monitoring concept. The published preview shows circuit-level monitoring and energy information.",
    image: "/images/portfolio/vel.png",
    alt: "Original VEL energy-monitoring application interface",
    category: "CONNECTED DATA · PROJECT CONCEPT",
  },
];
